import { AutocompleteValue, Autocomplete, TextField } from "@mui/material";
import { useCallback } from "react";
import { useGetProvidersQuery } from "src/api/services/providersApi";
import { ProviderProfile } from "src/api/types";

type Props<Multiple extends boolean, T> = {
  required?: boolean;
  multiple?: Multiple;
  value: Multiple extends true ? T[] : T | null;
  onChange: (value: Multiple extends true ? T[] : T | null) => void;
  select: (p: ProviderProfile) => T;
};

function ProviderSelect<
  T extends Pick<ProviderProfile, "id" | "profile">,
  Multiple extends boolean = false,
>({ multiple, value, onChange, select, required = false }: Props<Multiple, T>) {
  const { data } = useGetProvidersQuery(undefined, {
    selectFromResult: ({ data }) => {
      return { data: data?.map(select) ?? [] };
    },
  });

  const handleProduct = useCallback(
    (
      _: React.SyntheticEvent<Element, Event>,
      value: AutocompleteValue<T, Multiple, false, false>,
    ) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <Autocomplete<T, Multiple, false, false>
      aria-required={required}
      multiple={multiple}
      options={data}
      getOptionLabel={(p) => `${p.profile.first_name} ${p.profile.last_name}`}
      value={value}
      onChange={handleProduct}
      renderInput={(params) => <TextField {...params} label={"Providers"} />}
    />
  );
}

export default ProviderSelect;
